import { images } from "ionicons/icons";
import {
  GET_CART_ITEMS_LIST_SUCCESS,
  DELETE_CART_ITEMS_LIST_SUCCESS,
  ADD_TO_CART_SUCCESS,
  FETCH_CART_ITEM_SUCCESS,
  DELETE_CART_ITEM_SUCCESS,
  UPLOAD_CART_IMAGES_SUCCESS,
  AVAILABLE_DATES_SUCCESS,
  AVAILABLE_SLOTS_SUCCESS,
  BOOKING_IMAGE_SUCCESS,
  APPLY_OFFER_CODE_SUCCESS,
  GET_MULTI_SERVICE_DETAILS_SUCCESS,
  DELETE_CART_IMAGE_SUCCESS,
  UPDATE_CART_ITEM_SUCCESS,
  LOGOUT_SUCCESS,
  STORE_CITY_SUCCESS,
  SAVE_SERVICE_DATA,
  INSERT_IMAGE_INTO_CART,
  DELETE_IMAGE_FROM_CARTIMAGES,
} from "../Types";

const initialState = {
  cart_items: [],
  cart_estimates: {},
  offer_code: "",
  time_slots: [],
  booking_image:"",
  dates: [],
  firstAvailable: "",
  lastAvailable: "",
  offer_status: "",
  offer_data: [],
  service_data: [],
  booking_details_service_data: [],
  userCurCity: "",
  service_data_value: [],
};

export function cartReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CART_ITEMS_LIST_SUCCESS:
      const { data = [] } = action.body;
      const obj = data.pop();
      const { estimate, items, offerCode } = obj;

      // console.log("CART ITEMS ===== ", items);
      return {
        ...state,
        cart_items: items,
        cart_estimates: estimate,
        offer_code: offerCode,
        service_data: items.length === 0 ? [] : state.service_data,
      };
    case DELETE_CART_ITEMS_LIST_SUCCESS:
      return { ...state, service_data: [], cart_items: [] };
    case ADD_TO_CART_SUCCESS:
      return { ...state };
    case FETCH_CART_ITEM_SUCCESS:
      return { ...state };
    case DELETE_CART_ITEM_SUCCESS:
      const { id = "" } = action.body.data.pop();
      return {
        ...state,
        service_data: state.service_data.filter((ele) => ele.cartItemId !== id),
        //cart_items: state.cart_items.filter((ele) => ele.cartItemId !== id),
      };
    case UPLOAD_CART_IMAGES_SUCCESS: {
      const { id = "" } = action.additionalData;
      return {
        ...state,
        service_data: state.service_data.map((ele) => {
          if (ele.cartItemId === id) {
            return {
              ...ele,
              images: !!ele.images
                ? [...ele.images, action.body.data[0].message]
                : [action.body.data[0].message],
            };
          }
          return ele;
        }),
      };
    }
    case AVAILABLE_DATES_SUCCESS:
      const dateArr = action.body.data;
      const obj1 = dateArr.pop();
      const { firstAvailable, lastAvailable, dates } = obj1;
      return {
        ...state,
        dates: dates,
        firstAvailable: firstAvailable,
        lastAvailable: lastAvailable,
      };
    case APPLY_OFFER_CODE_SUCCESS:
      return { ...state };
    case AVAILABLE_SLOTS_SUCCESS:
      const time_slots = action.body.data;
      return { ...state, time_slots };
    case BOOKING_IMAGE_SUCCESS:
      const booking_image = action.body.data;
      return { ...state, booking_image };
    case GET_MULTI_SERVICE_DETAILS_SUCCESS: {
      const service_arr = action.body.data;
      const cart_arr = state.cart_items;
      // const merge = service_arr.map((t1) => ({
      //   addOnSections: t1.addOnSections,
      //   ...t1.service,
      //   ...cart_arr.find((t2) => t2.serviceId === t1.service.serviceId),
      // }));

      return {
        ...state,
        service_data_value: action.body.data,
        // booking_details_service_data: merge,
      };
    }
    case SAVE_SERVICE_DATA: {
      return {
        ...state,
        service_data: action.serviceData,
      };
    }
    case DELETE_CART_IMAGE_SUCCESS: {
      const { url = "" } = action.additionalData;
      return {
        ...state,
        service_data: state.service_data.map((ele) => {
          return {
            ...ele,
            images: !!ele.images
              ? ele.images.filter((img) => {
                  return img.split("/").pop() !== url.split("/").pop();
                })
              : [],
          };
        }),
      };
    }
    case UPDATE_CART_ITEM_SUCCESS: {
      const { body = {} } = action.additionalData;
      return {
        ...state,
        service_data: state.service_data.map((ele) => {
          if (ele.cartItemId === body.cartItemId) {
            return {
              ...ele,
              addOnsSelected: body.addOnsSelected,
            };
          }
          return ele;
        }),
        cart_items: state.cart_items.map((ele) => {
          if (ele.cartItemId === body.cartItemId) {
            return {
              ...ele,
              addOnsSelected: body.addOnsSelected,
            };
          }
          return ele;
        }),
      };
    }
    case STORE_CITY_SUCCESS: {
      const { currentCity } = action;
      return { ...state, userCurCity: currentCity };
    }
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    case INSERT_IMAGE_INTO_CART: {
      return {
        ...state,
        cart_items: state.cart_items.map((item) => {
          if (item.cartItemId === action.itemId) {
            return {
              ...item,
              images: action.imagesArr,
            };
          } else {
            return { ...item };
          }
        }),
        service_data: state.service_data.map((item) => {
          if (item.cartItemId === action.itemId) {
            return {
              ...item,
              images: action.imagesArr,
            };
          } else {
            return { ...item };
          }
        }),
      };
    }
    case DELETE_IMAGE_FROM_CARTIMAGES: {
      return {
        ...state,
        cart_items: state.cart_items.map((item) => {
          if (item.cartItemId === action.itemId) {
            return {
              ...item,
              images: action.imagesArr,
            };
          } else {
            return { ...item };
          }
        }),
      };
    }
    default:
      return state;
  }
}
